export default __webpack_public_path__ + "static/media/insurances.36616005.png";